<template>
  <div>
    <el-row class="header">
      <el-col :span="24">
        <el-date-picker v-model="beginDate" type="date" placeholder="请选择开始的日期" value-format="yyyyMMdd" size="small" class="ml" :picker-options="pickerOptions"> </el-date-picker>
        <el-date-picker v-model="endDate" type="date" placeholder="请选择结束的日期" value-format="yyyyMMdd" size="small" class="ml" :picker-options="pickerOptions"> </el-date-picker>
        <el-button type="primary" size="small" @click="getData" class="ml">查询</el-button>
      </el-col>
    </el-row>

    <!-- <el-table :data="datas" border :height="210" style="width: 100%;" highlight-current-row v-if="isLoad"> -->
    <el-table :data="datas" border :height="height" style="width: 100%;" highlight-current-row>
      <!-- <el-table-column prop="underlying" label="标的代码"> </el-table-column>
      <el-table-column prop="contractNo" label="持仓编号"></el-table-column>
      <el-table-column prop="subAccountNo" label="子账业务" :formatter="changeSubNo"> </el-table-column>
      <el-table-column prop="orderNo" label="委托号"></el-table-column>
      <el-table-column label="买卖方向">
        <template slot-scope="scope">
          <span> {{ scope.row.buySell == "B"?"买":"卖" }} </span>
        </template>
      </el-table-column>
      <el-table-column label="场外开平方向">
        <template slot-scope="scope">
          <span> {{ scope.row.openClose == "O"?"开":"平" }} </span>
        </template>
      </el-table-column>
      <el-table-column label="成交日期">
        <template slot-scope="scope">
          <span> {{ changeTime(scope.row.tradeDate) }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="tradePrice" label="成交价"></el-table-column>
      <el-table-column prop="tradeVolume" label="成交手数"></el-table-column>
      <el-table-column label="手续费">
        <template slot-scope="scope">
          <span> {{ (Number(scope.row.closeCollectCommission).toFixed(2) * 100 + Number(scope.row.openCollectCommission).toFixed(2) * 100) / 100 }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="投机套保标识">
        <template slot-scope="scope">
          <span> {{ changehedgeFlag( scope.row.hedgeFlag ) }} </span>
        </template>
      </el-table-column> -->

      <el-table-column v-for="item in showFields" :key="item.value" :prop="item.value" :label="item.key" show-overflow-tooltip>  </el-table-column>

      <!-- <el-table-column label="操作">
        <template slot-scope="scope">
          <div>
            <el-button type="danger" size="mini" @click="del(scope.row.orderNo)">撤单</el-button>
          </div>
        </template>
      </el-table-column> -->
    </el-table>

    <el-dialog title="改变显示字段" :visible.sync="dialogShowFields" :before-close="beforeClose">
      <el-transfer v-model="showValue" :data="allFields" @left-check-change="leftChange" @right-check-change="rightChange" target-order="push" :titles="['所有字段', '需显示字段']"></el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="enter">设置</el-button>
        <el-button type="primary" size="mini" @click="beforeClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import axios from '@/axios'
  import $ from 'jquery'
  import g from '@/components/Global.vue'
  import bus from '@/assets/eventBus'
  import Jq from 'jquery'
  export default {
    name: 'offer_mab',
    data() {
      return {
        sub: '',
        id: '',
        user: '',
        dis: false,

        tableData: [],
        hisMabData: [],
        datas: [],
        beginDate: new Date(),
        endDate: new Date(),
        flag: false,
        // 页码
        page: 1,
        total: 100,
        pageSize: 100,

        entexpands: [], //用于实现点击整行显示数据
        widths: [], //用于存放根据浏览器窗口大小改变宽度

        daochudisabled: true,

        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          },
        },

        // 用于转化数据
        hedgeFlagOptions: [{
            value: 1,
            label: "投机"
          },
          {
            value: 2,
            label: "套利"
          },
          {
            value: 3,
            label: "套保"
          },
          {
            value: 4,
            label: "备兑"
          }
        ],

         // 切换显示的字段
        dialogShowFields: false,
        showValue: [],    //穿梭框显示的字段集合
        allFields: [    //穿梭框全部字段集合
          {value: 'exchange', key: '交易所'},
          {value: 'underlying', key: '标的代码'},
          {value: 'contractNo', key: '持仓编号'},
          {value: 'subAccountName', key: '子账业务'},
          {value: 'orderNo', key: '委托号'},
          {value: 'buySellValue', key: '买卖方向'},
          {value: 'openCloseValue', key: '场外开平方向'},
          {value: 'tradeDateValue', key: '成交日期'},
          {value: 'tradePrice', key: '成交价'},
          {value: 'tradeVolume', key: '成交手数'},
          {value: 'commission', key: '手续费'},
          {value: 'hedgeFlagValue', key: '投机套保标识'},
        ],  
        showFields: [],
        isLoad: true,
      }
    },
    created() {
      bus.$on("daochuMab", this.daochu)
      bus.$on("compileMab", this.openDialog)  
      
    },
    destroyed() {

    },
    beforeDestroy() {
      bus.$off("daochuMab")
      bus.$off("compileMab")  
    },
    methods: {
      getTime() {
        let time = this.timeFormat(new Date())
        this.beginDate = time
        this.endDate = time
        // this.PositionChange()
      },
      daochu() {
        // window.open(`${g.baseURL}client/forward/excel/exportForwardTrades.do?clientBindId=${this.id}&beginDate=${this.beginDate}&endDate=${this.endDate}&subAccountNos=${[this.sub]}`)
        this.postDown(`${g.baseURL}client/forward/excel/exportForwardTrades.do`, {
          'clientBindId': this.id,
          'beginDate': this.beginDate,
          'endDate': this.endDate,
          'subAccountNos[]': this.sub
        })
      },

      // 改变显示的字段
      getShowFields() {   //获取显示的字段
        this.isLoad = false
        axios.post("client/queryClientForwardFieldInformation.do", this.qs.stringify({
          clientBindId: this.id, 
          businessType: 2,
        })).then(result => {
          if(result.data.success) {
            let datas = JSON.parse(result.data.fieldInformation)
            if(datas && datas.length) {
              this.showFields = datas
              this.isLoad = true
            } else {
              this.showFields = this.allFields
              this.isLoad = true
            }
          }
        }).catch(err => {
          this.isLoad = true
        })
      },
      enter() {
        let arr = []
        this.showValue.forEach(list => {
          this.allFields.forEach(item => {
            if(list === item.key) {
              arr.push(item)
            }
          })
        })

        axios.post("client/addClientForwardFieldInformation.do", this.qs.stringify({
          clientBindId: this.id,
          businessType: 2,
          fieldInformation: JSON.stringify(arr)
        })).then(result => {
          if(result.data.success) {
            this.$message.success("设置成功")
            this.getShowFields()
          }
        })

        // let datas = this.clone(this.tableFields)
        // datas.entrustHis = arr
        // bus.$emit("changeFields", datas)
        this.beforeClose()
      },
       //成交单分页
      getData(val) {
        if (this.flag) {
          this.hint()
          return
        }
        let beginDate = this.beginDate
        let endDate = this.endDate
        let now = this.timeFormat()
        if(beginDate === now) {
          this.datas = this.tableData
          return
        }
        if(endDate === now) endDate = this.currentBeforeDate()
        let _this = this
        axios.post("client/forward/forwardtrade/queryPage.do", this.qs.stringify({
          clientBindId: _this.id,
          pageno: _this.page,
          pagesize: _this.pageSize,
          beginDate: beginDate,
          endDate: endDate,
          'subAccountNos[]': this.sub,
        })).then(result => {
          if (result.data.success) {
              _this.hisMabData = result.data.page.datas
              _this.hisMabData.forEach(item => {
                _this.$set(item, 'subAccountName', _this.changeSubNo(item))
                _this.$set(item, 'buySellValue', item.buySell == "B"?"买":"卖")
                _this.$set(item, 'openCloseValue', item.openClose == "O"?"开":"平")
                _this.$set(item, 'tradeDateValue', item.tradeDate)
                _this.$set(item, 'commission', _this.add(item.closeCollectCommission, item.openCollectCommission).toFixed(2))
                _this.$set(item, 'hedgeFlagValue', _this.changehedgeFlag(item.hedgeFlag))
              })
              if(this.beginDate >= now) {
                this.datas = this.tableData
              } else if(this.endDate >= now) {
                this.datas = [...this.tableData, ...this.hisMabData, ]
              } else if(this.endDate < now) {
                this.datas = [...this.hisMabData]
              }
              
              let num = _this.pageSize * _this.page
              if (result.data.page.totalsize > num) {
                _this.pageSize = result.data.page.totalsize;
                _this.getData()
              }
            } else {
              _this.hisMabData = []
              if(this.beginDate >= now) {
                this.datas = this.tableData
              } else if(this.endDate >= now) {
                this.datas = [...this.tableData, ...this.hisMabData, ]
              } else if(this.endDate < now) {
                this.datas = [...this.hisMabData]
              }
            }
        })
      },

      beforeClose() {
        this.showValue = []
        this.dialogShowFields = false
      },
      leftChange(arr) {
        this.showValue = [...this.showValue, ...arr]
      },
      rightChange(arr) {
        arr.forEach(list => {
          for(let i = 0; i < this.showValue.length; i++) {
            if(list === this.showValue[i]) {
              this.showValue.splice(i, 1)
            }
          }
        })
      },

      openDialog() {
        let arr = []
        this.showFields.forEach(item => {
          arr.push(item.key)
        })
         this.showValue = arr
        this.dialogShowFields = true
      },

      // 检测时间，开始时间不能大于结束时间
      changeStart(val) {
        let start = val.getTime()
        let end = this.endDate.getTime()
        if (start > end) {
          this.hint()
          this.flag = true
        } else {
          this.flag = false
        }
      },
      changeEnd(val) {
        let start = this.beginDate.getTime()
        let end = val.getTime()
        if (start > end) {
          this.hint()
          this.flag = true
        } else {
          this.flag = false
        }
      },
      hint() {
        this.$message({
          type: "error",
          message: "开始日期不能大于结束日期，请重新选择",
          showClose: true,
        })
      },
      // 处理表单数据
      changeTime(val) {
        return this.timeFormat(new Date(val), "-")
      },
      direction(open, buy) {
        let o = open == "O" ? "开" : "平"
        let b = buy == "B" ? "买" : "卖"
        return b + o
      },
      changehedgeFlag(val) {
        let str = ''
        val = String.fromCharCode(val)
        this.hedgeFlagOptions.forEach(item => {
          if (item.value == val) {
            str = item.label
          }
        })
        return str
      },
      changeSubNo(obj) {
        let arr = this.subNos.filter((item) => {
          return item.subAccountNo == obj.subAccountNo
        })
        return arr[0].subAccountBusinessName
      },
    },
    watch: {
      $route: {
        handler(to, from) {
          this.dis = to.query.dis
          let user = to.query.user
          let id = to.query.id
          let sub = to.query.sub
          if ( to.path == '/newLayoutForword' && user && id && sub) {
            this.sub = to.query.sub
            this.id = to.query.id
            this.user = to.query.user
            this.getTime()
            this.showFields = this.allFields
            this.getShowFields()
          } else {
  
          }
        },
        immediate: true
      },
      showData: {
        handler(newValue, oldValue) {
          this.tableData = newValue
          if (newValue.length > 0) {
            this.daochudisabled = false
            bus.$emit("changeEntrustFlag", false)

            this.tableData.forEach(item => {
              this.$set(item, 'subAccountName', this.changeSubNo(item))
              this.$set(item, 'buySellValue', item.buySell == "B"?"买":"卖")
              this.$set(item, 'openCloseValue', item.openClose == "O"?"开":"平")
              this.$set(item, 'tradeDateValue', item.tradeDate)
              this.$set(item, 'commission', this.add(item.closeCollectCommission, item.openCollectCommission).toFixed(2))
              this.$set(item, 'hedgeFlagValue', this.changehedgeFlag(item.hedgeFlag))
            })
            let beginDate = this.beginDate
            let endDate = this.endDate
            let now = this.timeFormat()

            if(beginDate >= now) {
              this.datas = this.tableData
            } else if(endDate >= now) {
              this.datas = [...this.tableData, ...this.hisMabData, ]
            } else if(endDate < now) {
              this.datas = [...this.hisMabData]
            }
            
          } else {
            this.daochudisabled = true
            bus.$emit("changeEntrustFlag", true)
          }
        },
        immediate: true
      },

    },
    props:['subNos', "showData", 'height']
  }

</script>

<style scoped>
.header {
  height: 40px;
  display: flex;
  align-items: center;
}
.ml {
  margin-left: 5px;
}
</style>
